<template>
  <div style="background-color: #fff !important;">
    <div class="title-box">视频AI事件列表</div>
    <!-- 查询条件 -->
    <el-form
      id="formID"
      :inline="true"
      :model="queryParams"
      style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
      class="demo-form-inline"
    >
      <el-row>
        <el-form-item>
          <el-select
            ref="factorySelect"
            v-model="queryParams.factoryId"
            filterable
            placeholder="选择工厂"
            clearable
            @change="getWorkshopByFactory"
          >
            <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            ref="workshopSelect"
            v-model="queryParams.workshopId"
            filterable
            clearable
            placeholder="选择车间"
            @change="getSceneByWorkshop"
          >
            <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select ref="sceneSelect" placeholder="选择场景" v-model="queryParams.sceneId" clearable filterable>
            <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="queryParams.eventStartTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="queryParams.eventEndTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
        <!-- 表格/图表切换 -->
        <!-- <el-form-item style="float: right"> -->
        <!-- 删除添加按钮 -->
        <!-- <span>
            <i
              @click="addVideoAiEvent"
              style="
                background: #c7c7c7;
                cursor: pointer;
                color: #fff;
                width: 32px;
                height: 32px;
                text-align: center;
                margin-top: 18px;
                padding-top: 7px;
                border-radius: 3px;
              "
              class="el-icon-plus"
            ></i>
          </span>
          <span v-hasPermi="['enterpr:diffpressure:export']" @click="exportData()" class="tool-icon">
            <img src="@/assets/images/download.png" />
          </span> -->
        <!-- </el-form-item> -->
      </el-row>
    </el-form>
    <div>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        :style="{ height: tableHeight + 'px', width: '100%', 'border-radius': '3px' }"
        class="custom-table-header"
      >
        <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
        <el-table-column prop="factoryName" label="工厂" align="center"></el-table-column>
        <el-table-column prop="workshopName" label="车间" align="center"></el-table-column>
        <el-table-column prop="sceneName" label="场景" align="center"></el-table-column>
        <el-table-column prop="algorithmId" label="算法ID" align="center"></el-table-column>
        <el-table-column prop="algorithmCode" label="算法编码" align="center"></el-table-column>
        <el-table-column prop="algorithmName" label="算法名称" align="center"></el-table-column>
        <el-table-column prop="channelName" label="通道名称" align="center"></el-table-column>
        <el-table-column prop="areaName" label="区域名称" align="center"></el-table-column>
        <el-table-column prop="fullPictureOssid" label="图片" align="center">
          <template #default="scope">
            <span v-if="scope.row.fullPictureOssid" @click="gotoPictureAi(scope.row)" class="ai-video">查看图片</span>
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="video" label="视频" align="center">
          <template #default="scope">
            <span v-if="scope.row.video" @click="gotoVideoFile(scope.row)" class="ai-video">查看视频</span>
            <span v-else>暂无视频</span>
          </template>
        </el-table-column>
        <el-table-column prop="timestamp" label="事件时间" align="center" :formatter="formatTimestamp"></el-table-column>
        <!-- <el-table-column label="事件视频" align="center">
          <template #default="scope">
            <span v-if="scope.row.deviceNums" @click="gotoVideoAi(scope.row)" class="ai-video">视频回放</span>
            <span v-else>暂无视频</span>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <div class="block" style="background: #fff; text-align: center; padding: 20px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNation.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageNation.pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="图片预览"
      :visible.sync="pictureDialogVisible"
      width="616px"
      class="list-picture-dialog"
      append-to-body
    >
      <div style="text-align:center;">
        <img v-if="pictureUrl" :src="pictureUrl" alt="事件图片" style="max-width:100%;max-height:500px;" />
      </div>
    </el-dialog>
    <el-dialog
      title="视频预览"
      :visible.sync="videoFileDialogVisible"
      width="616px"
      append-to-body
    >
      <div style="width:100%;">
        <video
          v-if="videoFileUrl"
          ref="videoPlayer"
          :src="videoFileUrl"
          :key="videoFileUrl"
          controls
          autoplay
          preload="auto"
          @error="handleVideoError"
          @loadeddata="handleVideoLoaded"
          style="width:100%;max-height:70vh;display:block;background:#000;"
        ></video>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :title="'视频回放'"
      :visible.sync="dialogVisible"
      width="616px"
      class="list-video-dialog"
      @open="openFn"
      @close="closeFn"
    >
      <div class="video-grid video">
        <div
          v-for="(item, index) in videonums"
          :key="`${index}-${curCell ? curCell.id : 'no-cell'}`"
          class="video-item item"
        >
          <div class="video-title">镜头{{ index + 1 }} - {{ item }}</div>
          <div class="video-player-container-box">
            <template v-if="item">
              <CustomPlayer
                ref="customPlayerRefs"
                :startTime="eventStartTime"
                :endTime="eventEndTime"
                videoType="history"
                :dev-num="item"
                :croping="false"
              />
            </template>
            <template v-else>
              <div class="no-video"></div>
            </template>
          </div>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { getDateOneWeekAgo, formatDate, formatDateTime } from '@/utils/base';
import * as echarts from 'echarts';
import { download } from '@/utils/request';
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';
import CustomPlayer from '@/components/customPlayer.vue';
export default {
  data() {
    return {
      // 查询条件
      queryParams: {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        eventStartTime: '',
        eventEndTime: ''
      },
      //工厂数据
      factoryOptions: [],
      // 车间数据
      workshopOptions: [],
      sceneOptions: [],
      deviceNumList: [],
      total: 0,
      tableHeight: 650,
      // 表格数据
      tableData: [],
      lineChart: null,
      sourceTime: [],
      pdiData: [],
      pageNation: {
        pageNum: 1,
        pageSize: 20
      },
      dialogVisible: false,
      videonums: [],
      eventStartTime: '',
      eventEndTime: '',
      pictureDialogVisible: false,
      pictureUrl: '',
      videoFileDialogVisible: false,
      videoFileUrl: ''
    };
  },
  components: {
    CustomPlayer
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    this.getList();
    this.getFactoryByCustomer();
  },
  methods: {
    // 格式化时间戳
    formatTimestamp(row, column, cellValue) {
      if (!cellValue) return '';
      // 如果是数字（毫秒时间戳），转为Date对象
      let date;
      if (typeof cellValue === 'number') {
        // 判断是秒级还是毫秒级时间戳
        date = new Date(cellValue > 9999999999 ? cellValue : cellValue * 1000);
      } else {
        // 如果是字符串，直接创建Date对象
        date = new Date(cellValue);
      }
      if (isNaN(date.getTime())) return cellValue;
      return formatDateTime(date);
    },
    // 删除
    handleDelete(row) {
      const aiEventId = row?.id;
      const aiEventName = '';
      MessageBox.confirm('是否确认删除' + aiEventName + '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          request
            .delete(`${api.cAiEventData.delVideoAiEvent}/${aiEventId}`)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                this.getList();
              } else {
                this.$message.error('删除失败');
              }
            })
            .catch((err) => {
              this.$message.error('删除失败');
            });
        })
        .catch(() => {});
    },
    // 查看图片
    gotoPictureAi(row){
      if (!row.fullPictureOssid) {
        return;
      }
      request.get(`${api.cAiEventData.getImgsUrl}/${row.fullPictureOssid}`).then((res) => {
        if (res.code === 200 && res.data) {
          this.pictureUrl = res.data[0].url;
          this.pictureDialogVisible = true;
        } else {
          this.$message.error('获取图片失败');
        }
      }).catch(() => {
        this.$message.error('获取图片失败');
      });
    },
    // 查看视频文件
    gotoVideoFile(row){
      if (!row.video) {
        return;
      }
      request.get(`${api.cAiEventData.getImgsUrl}/${row.video}`).then((res) => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          // 通过 dev-server 的 /obs-video 自定义中间件转发：
          // 1) 保留原始 URL 签名（Node.js http 模块直接转发，不修改 query string 编码）
          // 2) 修正 OBS 返回的 Content-Type 为 video/mp4，让浏览器能识别为视频
          const obsUrl = res.data[0].url;
          this.videoFileUrl = obsUrl;
          this.videoFileDialogVisible = true;
        } else {
          this.$message.error('获取视频失败');
        }
      }).catch(() => {
        this.$message.error('获取视频失败');
      });
    },
    // 视频加载错误处理
    handleVideoError(e) {
      console.error('视频加载失败:', e.target.error, 'URL:', this.videoFileUrl);
      this.$message.error('视频加载失败，请检查视频地址是否可访问');
    },
    // 视频加载成功
    handleVideoLoaded(e) {
      console.log('视频加载成功:', this.videoFileUrl);
    },
    gotoVideoAi(row) {
      if (!row.deviceNums.length) {
        return;
      }
      this.dialogVisible = true;
      this.eventStartTime = row.eventStartTime;
      this.eventEndTime = row.eventEndTime;
      this.videonums = row.deviceNums.split(',');
    },
    // 添加视频Ai事件
    addVideoAiEvent() {},
    // 监听窗口缩放
    handleResize() {
      // 当窗口大小变化时，这个函数会被调用
      const height = window.innerHeight;
      // 你可以在这里添加你的处理代码
      let dom = document.getElementById('formID');
      let formH = 70; //一行时高度为70
      if (dom) {
        formH = dom.offsetHeight;
      }
      this.tableHeight = height - 190 - formH; //表单的高度会变化
      // 设置表格体高度
      let tableBody = document.getElementsByClassName('el-table__body-wrapper')[0];
      if (tableBody) {
        tableBody.style.height = this.tableHeight - 40 + 'px';
      }

      if (this.lineChart) {
        this.lineChart.resize();
      }
    },
    // 查询
    onSubmit() {
      this.getList();
    },
    // 重置
    onReset() {
      let eDate = formatDate(new Date());
      let sDate = getDateOneWeekAgo(3);
      this.queryParams = {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        eventStartTime: '',
        eventEndTime: ''
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNation.pageNum = 1;
      this.pageNation.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNation.pageNum = val;
      this.getList();
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store.dispatch('workshop/getFactoryByCustomer').then((result) => {
        this.factoryOptions = result?.data;
      });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store.dispatch('scene/getWorkshopByFactory', { factoryId: this.queryParams.factoryId }).then((result) => {
        this.queryParams.workshopId = null;
        if (result && result.data && result.data.length > 0) {
          this.workshopOptions = result.data;
        } else {
          this.workshopOptions = [];
        }
      });
    },
    // 根据车间查询场景
    getSceneByWorkshop() {
      this.$store
        .dispatch('monitorData/getSceneByWorkshop', { workshopId: this.queryParams.workshopId })
        .then((result) => {
          this.queryParams.sceneId = null;
          if (result && result.data && result.data.length > 0) {
            this.sceneOptions = result.data;
          } else {
            this.sceneOptions = [];
          }
        });
    },

    getList() {
      const params = {
        ...this.queryParams,
        ...this.pageNation
      };
      request
        .get(`${api.cAiEventData.getCameraEventList}`, {
          params: params
        })
        .then((res) => {
          if (res.code === 200 && res?.rows) {
            this.tableData = res.rows || [];
            this.total = res.total || 0;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch((err) => {
          this.tableData = [];
          this.total = 0;
        });
    },
    // 导出
    exportData() {
      const params = { ...this.queryParams, ...this.pageNation };
      download(
        '/biz/event/camera/export',
        {
          ...params
        },
        `eventCamera_${new Date().getTime()}.xlsx`
      );
    }
  }
};
</script>

<style scoped lang="scss">
.ai-video {
  color: #3083fb;
  cursor: pointer;
}
.title-box {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  padding: 27px 0 15px;
  line-height: 16px;
}
// 表头背景色
::v-deep .custom-table-header th {
  background-color: #ebeef5 !important;
}
// 表格字体大小
.el-table {
  font-size: 12px;
}
// 表单底部边界线
.el-table::before {
  height: 0px;
}
// 表格字体
::v-deep .el-table thead {
  color: #606266;
}
// 表格内边距
::v-deep .el-table .el-table__cell {
  padding: 8px 0;
}
// 表单底部margin
.el-form-item {
  margin-bottom: 0;
}
// 当前页码样式
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff9f07;
}
// 页面hover样式
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff9f07;
}
// .el-button{
//     font-size: 12px;
// }
::v-deep .el-form-item__label {
  font-size: 12px;
}
::v-deep .el-table__body-wrapper {
  height: 100%;
  overflow-y: auto;
}
.tool-icon {
  width: 28px;
  height: 32px;
  cursor: pointer;
  background: #c7c7c7;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  border-radius: 4px;
  margin-left: 5px;
}
.select-icon {
  background: #3083fb;
}
</style>
<style lang="scss">
.el-dialog__wrapper.list-video-file-dialog {
  .el-dialog__body {
    padding: 20px;
    .video-file-wrap {
      width: 100%;
      video {
        width: 100%;
        max-height: 70vh;
        display: block;
        background: #000;
      }
    }
  }
}
.el-dialog__wrapper.list-video-dialog {
  .el-dialog__body {
    padding: 20px;
    max-height: 500px;
    overflow: auto;

    .video-grid {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      align-items: flex-start;

      .video-title {
        height: 20px;
        line-height: 20px;
        font-size: 8px;
        padding-left: 10px;
        text-align: left;
        width: 100%;
        background-color: #4f5566;
        color: #fff;
      }

      .video-item {
        height: 300px;
        width: 100%;
        border: 1px solid #ccc;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        margin-bottom: 10px;
        border-radius: 8px;
        overflow: hidden;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .video-player-container-box {
      width: 100%;
      height: calc(100% - 20px);
      cursor: pointer;
      background: #000;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      .no-video {
        width: 108px;
        height: 108px;
        background: url('@/assets/images/no-video.png') no-repeat center center;
        cursor: not-allowed;
      }

      &:hover {
        .volume-control-wrapper {
          opacity: 1;
        }

        .player-controls {
          opacity: 1;
        }
      }
    }
  }
}

.volume-popper.el-popper {
  min-width: unset;
  .popper__arrow {
    display: none;
  }
}
</style>
